import { Button } from '@amzn/awsui-components-core';
import download from 'downloadjs';
import Papa from 'papaparse';
import React from 'react';
import constants from '../../common/constants';

interface Props {
  format: Array<{ header: string; value: (i: any) => any }>;
  data: readonly any[];
  filename: string;
  buttonText?: string;
  renderInline?: boolean;
}

class CsvDownloadButton extends React.Component<Props> {
  public render() {
    if (this.props.renderInline) {
      return (
        <Button
          iconName="download"
          variant="icon"
          ariaLabel="Download CSV"
          onClick={this.handleDownloadClicked}
        />
      );
    } else {
      return (
        <div>
          <Button iconName="download" onClick={this.handleDownloadClicked}>
            {this.props.buttonText || constants.DOWNLOAD_AS_CSV}
          </Button>
        </div>
      );
    }
  }
  private handleDownloadClicked = () => {
    const { data, filename, format } = this.props;
    const csvItems: Array<{}> = [];
    for (const item of data) {
      const csvItem = format.reduce((acc, cur) => {
        // @ts-expect-error TS7053 - strict migration
        acc[cur.header] = cur.value(item);
        return acc;
      }, {});
      csvItems.push(csvItem);
    }

    const unparsed = Papa.unparse(
      { data: csvItems, fields: format.map((f) => f.header) },
      { escapeFormulae: true },
    );

    return download(unparsed, filename, 'text/csv');
  };
}

export default CsvDownloadButton;
